import { useState } from "react";
export default () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    afterChange: (current) => setActiveIndex(current),
    appendDots: (dots) => (
      <div>
        <ul className="flex justify-end xs:gap-1 sm:gap-2 2xl:gap-x-3 3xl:gap-x-6">
          {dots}
        </ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        className={`absolute bottom-12 right-5 rounded-lg 
            xs:w-6 xs:h-[3px] sm:w-7 sm:h-1 2xl:w-8 2xl:h-1 
            3xl:w-10 3xl:h-[5px] 
            ${
              activeIndex === i
                ? "bg-orangeCrayola scale-125 shadow-md"
                : "bg-graniteGray scale-100"
            } 
            transition-transform duration-200 ease-in-out`}
      ></div>
    ),
  };

  return { settings };
};
